import React from "react";
import { Link } from "react-router-dom";
import GlowCanvasLogo from "./GlowCanvasLogo";

export default function Footer() {
  return (
    <footer className="w-full bg-black border-t border-gray-800 pt-9 pb-5">
      <div className="max-w-[1440px] mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-8">
        {/* Logo */}
        <Link to="/">
          <div className="flex items-center">
            <GlowCanvasLogo />
          </div>
        </Link>
        
        {/* Navigation Links */}
        <div className="flex flex-col md:flex-row gap-5">
          <Link to="/terms" className="text-gray-300 text-[1.1rem] font-normal hover:text-white transition">
            Terms
          </Link>
          <Link to="/privacy" className="text-gray-300 text-[1.1rem] font-normal hover:text-white transition">
            Privacy
          </Link>
          <a href="mailto:support@glowcanvas.io" className="text-gray-300 text-[1.1rem] font-normal hover:text-white transition">
            Contact
          </a>
          <Link to="/blog" className="text-gray-300 text-[1.1rem] font-normal hover:text-white transition">
            Blog
          </Link>
        </div>
        
        {/* Copyright */}
        <div className="text-gray-500 text-[0.98rem] font-normal mt-2 md:mt-0 whitespace-nowrap">
          © {new Date().getFullYear()} GlowCanvas · All rights reserved
        </div>
      </div>
    </footer>
  );
}
